import React from "react";

import BaseIcon from "../BaseIcon";

const CitroenLogo = props => (
  <BaseIcon viewBox="0 0 43.248 53.67" size="xl" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.624 0c-11.923 0-21.624 12.038-21.624 26.835s9.7 26.835 21.624 26.835 21.624-12.038 21.624-26.835-9.701-26.835-21.624-26.835zm-17.635 36.123-0.02-0.063a23.373 23.373 0 0 1-0.932-4.177v-0.027l0.022-0.016 18.57-13.733 18.594 13.749v0.027a23.4 23.4 0 0 1-0.932 4.177l-0.02 0.063-0.053-0.039-17.585-13.043-17.644 13.088zm17.638 15.014c-6.193 0-11.991-3.836-15.58-10.28l-0.043-0.083 15.622-11.552 15.624 11.553-0.041 0.074c-3.59 6.45-9.388 10.288-15.585 10.288zm0-39.312-19.078 14.148v-0.1a27.547 27.547 0 0 1 5.828-16.526c3.579-4.4 8.282-6.816 13.243-6.816s9.664 2.421 13.243 6.816a27.548 27.548 0 0 1 5.828 16.526v0.1l-0.079-0.058z"
    />
  </BaseIcon>
);

export default CitroenLogo;
